<template>
  <div style="height: 100%">
    <!-- 标题和切换按钮 -->
    <div class="header-row">
      <label style="padding: 20px 0 0 30px;">上月{{ currentType === 'elec' ? 'PUE' : 'WUE' }}值</label>
      <!-- <div class="switch-buttons">
        <el-button 
          size="mini" 
          :type="currentType === 'elec' ? 'primary' : 'info'"
          @click="switchType('elec')">PUE</el-button>
        <el-button 
          size="mini"
          :type="currentType === 'water' ? 'primary' : 'info'"
          @click="switchType('water')">WUE</el-button>
      </div> -->
    </div>
    
    <!-- 图表区域 -->
    <el-row style="height: 40%;width: 100%">
      <el-col :span="24" style="width: 100%;height: 100%;position: relative">
        <pue-gauge :data="pueValue" ref="PueGauge" style="height: 100%"></pue-gauge>
        <el-row
          style="text-align: center;font-size: 14px;position: absolute;left: 0;bottom: 8%;height: 10%;width: 100%">
          <el-col :span="12">{{ currentType === 'elec' ? '总能耗值' : '总用水量' }}：{{ power }} {{ currentType === 'elec' ? 'kw·h' : 'm³' }}</el-col>
          <el-col :span="12">IT设备能耗值：{{ itPower }} kw·h</el-col>
        </el-row>
      </el-col>
    </el-row>
    
    <!-- 趋势图区域 -->
    <el-row style="height: 60%;width: 100%">
      <el-row>
        <el-col :span="12">
          <label style="padding: 0 0 0 30px;">{{ currentType === 'elec' ? 'PUE' : 'WUE' }}变化趋势</label>
        </el-col>
        <el-col :span="12" style="text-align: center">动力辅助能耗值：{{ powerAssist }} kw·h</el-col>
      </el-row>
      <el-col :span="24" style="width: 100%;height: 100%;padding-left: 8%">
        <LineChartPue1 ref="LineChartPue1" v-if="lineData.time!==null"
                       :data="lineData"
                       :extend-data="lineExtentData"
                       style="height: 65%"></LineChartPue1>
        <no-data v-else></no-data>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import NoData from "@/components/NoData";
import pueGauge from "@/components/echarts/pueGauge";
import LineChartPue1 from "@/components/echarts/LineChartPue1"
import {getYearTrend, getLastMonthPue} from "@/network/ems-record.js"

export default {
  name: "RealValuePue",
  components: {
    pueGauge, LineChartPue1, NoData
  },
  props: {
    // 是否开启自动轮显
    autoSwitch: {
      type: Boolean,
      default: true
    },
    // 轮显间隔时间(毫秒)
    switchInterval: {
      type: Number,
      default: 10000  // 默认10秒切换一次
    }
  },
  data() {
    return {
      // 当前类型 'elec'=PUE, 'water'=WUE
      currentType: 'elec',
      date: [],//日期选择
      extendData: null,
      lineData: {
        time: null,
        value: null
      },
      lineExtentData: {'xAxis': [{'axisLabel': {'rotate': 45}}]},
      pueValue: 0,
      itPower: 0,
      power: 0,
      // 轮显定时器
      switchTimer: null
    };
  },
  computed: {
    powerAssist() {
      return (this.power - this.itPower).toFixed(1)
    }
  },
  mounted() {
    this.getData();
    
    // 如果开启自动轮显，启动定时器
    if (this.autoSwitch) {
      this.startAutoSwitch();
    }
  },
  beforeDestroy() {
    // 清除轮显定时器
    this.clearAutoSwitch();
  },
  methods: {
    // 切换到指定类型
    switchType(type) {
      if (this.currentType !== type) {
        this.currentType = type;
        this.getData();
        
        // 手动切换后，重置自动轮显定时器
        if (this.autoSwitch) {
          this.clearAutoSwitch();
          this.startAutoSwitch();
        }
      }
    },
    
    // 开始自动轮显
    startAutoSwitch() {
      this.clearAutoSwitch(); // 确保先清除现有定时器
      this.switchTimer = setInterval(() => {
        this.switchType(this.currentType === 'elec' ? 'water' : 'elec');
      }, this.switchInterval);
    },
    
    // 清除自动轮显定时器
    clearAutoSwitch() {
      if (this.switchTimer) {
        clearInterval(this.switchTimer);
        this.switchTimer = null;
      }
    },
    
    // 获取并更新数据
    getData() {
      this.getLineData();
      this.getRealTimePue();
    },
    
    // 变化趋势数据
    getLineData() {
      getYearTrend(this.currentType).then(res => {
        if (res.code === 0 && res.data !== null) {
          this.lineData = res.data;
          this.lineData.time = res.data.months;
          this.lineData.value = res.data.values;
        } else {
          this.lineData = { time: null, value: null };
        }
      }).catch(() => {
        this.lineData = { time: null, value: null };
      });
    },
    
    // 实时值数据
    getRealTimePue() {
      getLastMonthPue(this.currentType).then(res => {
        if (res.code === 0 && res.data && res.data.pueValue !== null) {
          this.pueValue = res.data.pueValue;
          this.itPower = res.data.itPower;
          this.power = res.data.power;
        } else {
          this.pueValue = 0;
          this.itPower = 0;
          this.power = 0;
        }
      }).catch(() => {
        this.pueValue = 0;
        this.itPower = 0;
        this.power = 0;
      });
    }
  }
}
</script>

<style scoped>
label {
  font-weight: bold;
  color: #01EFFD;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-right: 20px;
}

.switch-buttons {
  margin-top: 20px;
  margin-right: 30px;
}

.switch-buttons .el-button {
  margin-left: 10px;
}
</style>
